<template>
  <div class="category-page-container">
    <h1 class="page-title">商品總覽</h1>
    <el-row :gutter="20" class="category-row" justify="center">
      <el-col
        v-for="category in categories"
        :key="category.value"
        :xs="24"
        :sm="12"
        :md="calculateMdSpan" 
        :lg="calculateLgSpan"
        class="category-col"
      >
        <el-card 
          shadow="hover" 
          class="category-card" 
          @click="navigateToCategory(category.value)"
        >
          <div class="category-content">
            <el-icon class="category-icon" :size="32">
              <component :is="category.icon" />
            </el-icon>
            <div class="category-name">
              {{ category.label }}
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { Suitcase, ShoppingBag, Watch, PriceTag, MostlyCloudy as ShoesIcon, CollectionTag } from '@element-plus/icons-vue';

const router = useRouter();

const categories = ref([
  { label: '水槽&洗碗槽', value: 'sink_and_dishwasher', icon: Suitcase },
  { label: '花架&花盆', value: 'flower_stand_and_pot', icon: ShoppingBag },
  { label: '床頭靠墊/床頭軟包', value: 'bed_head_cushion', icon: ShoesIcon },
  { label: '山水畫', value: 'landscape_painting', icon: PriceTag },
  { label: '塌塌米豆帶沙發', value: 'tatami_sofa', icon: CollectionTag },
  { label: '長凳子/長條椅', value: 'bench', icon: Suitcase },
  { label: '角鋼架/貨架', value: 'steel_shelf', icon: ShoppingBag },
  { label: '貓爬架/貓窩/貓屋', value: 'cat_tree_and_house', icon: ShoesIcon },
  { label: '戶外沙發', value: 'outdoor_sofa', icon: Watch },
  { label: '人台/服裝模特', value: 'mannequin', icon: PriceTag },
  { label: '蚊帳', value: 'mosquito_net', icon: CollectionTag },
  { label: '健身器材', value: 'fitness_equipment', icon: Suitcase },
  { label: '衣櫥/衣櫃/衣架', value: 'wardrobe_and_rack', icon: ShoppingBag },
  { label: '鏡櫃', value: 'mirror_cabinet', icon: ShoesIcon },
  { label: '沙發/電腦椅/長椅', value: 'sofa_and_chair', icon: CollectionTag },
  { label: '汽車配件', value: 'automotive_parts', icon: PriceTag },
]);

const navigateToCategory = (kindValue) => {
  if (kindValue) {
    router.push({ path: `/types/${kindValue}` });
  } else {
    console.warn('Category value (kind) is not defined');
  }
};

const calculateMdSpan = computed(() => {
  return 8; // 一行3个
});

const calculateLgSpan = computed(() => {
  return 4; // 5个span为4的元素总宽度为20，在24栅格中会有4的空隙。可以通过 justify="center" 来居中。

});

</script>

<style scoped>
.category-page-container {
  padding: 30px;
  /* background-color: #f4f6f8; */
  min-height: 80vh;
}

.page-title {
  text-align: center;
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 40px;
  font-weight: 600;
  letter-spacing: 1px;
}

.category-col {
  margin-bottom: 20px;
  display: flex; 
  justify-content: center;
}

.category-card {
  width: 100%; 
  max-width: 280px; 
  border-radius: 12px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  overflow: hidden;
}

.category-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  background-color: #fff;
}

.category-card:hover {
  transform: translateY(-8px) scale(1.03);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

.category-icon {
  color: #409EFF;
  margin-bottom: 12px;
}

.category-name {
  padding: 4px 15px 12px;
  text-align: center;
  font-size: 1.1rem;
  font-weight: 500;
  color: #495057;
}

@media (max-width: 991px) { /* md 断点以下 */
  .category-col {
     /* 在 md 断点，每行3个，如果 el-col :md="8" */
  }
}

@media (max-width: 767px) { /* sm 断点以下 */
  .page-title {
    font-size: 2rem;
    margin-bottom: 30px;
  }
  .category-card {
    max-width: none; 
  }
   /* 在 sm 断点，每行2个，如果 el-col :sm="12" */
}

@media (min-width: 1200px) { /* lg 断点以上，我们有5个分类 */
  .category-col {
    /* 如果使用 :lg="4"，5个元素会是 4+4+4+4+4 = 20，还剩4的宽度 */
    /* 如果希望它们更紧凑，可以给 .category-row 设置 max-width */
    /* 或者用更精确的 flex 布局，而不是依赖栅格的 span */
     flex: 0 0 calc(20% - 20px); /* 假设 gutter 是 20px，尝试让每个占20%宽度 */
     max-width: calc(20% - 20px);
     /* 上述 flex 计算可能因 gutter 而复杂，最简单的是让 el-row justify-content:center */
  }
}
</style>
